<template>
  <div class='guest'>
    <div class="top">
      <h3>Guest {{ 1 + guest }}</h3>
      <GuestButton text="x" @click="$emit('removeGuest', guest)" />
    </div>
    <input type="text" v-model="info.first" placeholder="first name" />
    <input type="text" v-model="info.last" placeholder="last name" />
    <input type="email" v-model="info.email" placeholder="email address" />
    <GuestButton text="x" @click="$emit('removeGuest', guest)" class='add-guest-desktop' />
  </div>
</template>

<script>
  import GuestButton from "@/components/GuestButton";
  export default {
    name: "GuestInfo",
    props: {
      guest: Number,
      info: Object
    },
    data() {
      return {
        first: "",
        last: "",
        email: "",
      };
    },
    components: {
      GuestButton,
    },
  };
</script>

<style lang="scss" scoped>
  @media (max-width:849px) {
    .add-guest-desktop {
      display: none;
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media (min-width:850px) {
      display: contents;

      button {
        display: none;
      }
    }
  }

  .label {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h3 {
    color: var(--black);
    font-family: "proxima-nova", sans-serif;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.26px;
    text-transform: uppercase;
  }

  .guest {
    display: flex;
    flex-direction: column;
    grid-template-columns: 85px 1fr 1fr 1fr 40px;
    gap: 5px;
    align-items: center;

    @media (min-width:850px) {
      display: grid;
    }
  }

  input {
    border: 2px solid rgba(#A5ACAF, 0.2);
    background: var(--white);
    padding: 16px 20px;
    color: var(--black);

    font-family: "proxima-nova", sans-serif;
    font-size: 16px;

    &::placeholder {
      opacity: 0.2;
      color: var(--black);
      font-family: "proxima-nova", sans-serif;
      font-size: 16px;
      font-weight: 600;
    }
  }
</style>